module.exports = __webpack_public_path__ + "static/leads-img-2-4160ba9462ae30ffefc1ac0647a39f2b.jpg";